import { mapState, mapActions } from "vuex";
import { chunk } from "lodash";

export let DataLayer = {
    data() {
        return {
            dl_click: false,
            dl_clickedObject: null,
            dl_detailsObject: null,
            dl_currentObjectType: null,
            dl_currentRoute: null,
        };
    },
    mounted() {
        // debugger;
    },
    computed: {
        ...mapState("willyou", ["currentStore", "lastImpressions"]),
        dl_getTypeName() {
            switch (this.dl_event) {
                case "product click":
                    return "click";
                case "product list":
                    return "impressions";
                case "product details":
                    return "detail";
            }
        },
        dl_ecommerceType() {
            let currentRoute = this.dl_currentRoute ?
                this.dl_currentRoute :
                this.$route.name;
            switch (currentRoute) {
                case "live-showcase":
                    return {
                        name: this.dl_getTypeName,
                        objectsLst: this.dl_getTypeObj("diamonds"),
                    };
                case "stores-search-results-by-city":
                    return {
                        name: this.dl_getTypeName,
                        objectsLst: this.dl_getTypeObj("jeweler-city"),
                    };
                case "find-a-jeweler-by-city":
                    return {
                        name: this.dl_getTypeName,
                        objectsLst: this.dl_getTypeObj("state-page"),
                    };
                case "find-a-jeweler-by-state":
                    return {
                        name: this.dl_getTypeName,
                        objectsLst: this.dl_getTypeObj("store-locator"),
                    };
                case "engagement-rings-search":
                    return {
                        name: this.dl_getTypeName,
                        objectsLst: this.dl_getTypeObj("rings"),
                    };
                case "engagement-rings-search-product-ring":
                    return {
                        name: this.dl_getTypeName,
                        objectsLst: this.dl_getTypeObj("rings"),
                    };
                case "diamonds-page":
                    return {
                        name: this.dl_getTypeName,
                        objectsLst: this.dl_getTypeObj("diamonds"),
                    };
                case "diamonds-page-diamond-popup":
                    return {
                        name: this.dl_getTypeName,
                        objectsLst: this.dl_getTypeObj("diamonds"),
                    };
                case "home-store":
                    return this.searchEngineType === "diamonds" ?
                        {
                            name: this.dl_getTypeName,
                            objectsLst: this.dl_getTypeObj("diamonds"),
                        } :
                        {
                            name: this.dl_getTypeName,
                            objectsLst: this.dl_getTypeObj("rings"),
                        };
                default:
                    return { name: "", objectsLst: null };
            }
        },
        dl_event() {
            let event = this.dl_click ? "product click" : "product list";
            event =
                this.dl_detailsObject && this.dl_detailsObject.name ?
                "product details" :
                event;
            return event;
        },
        dl_ecommerceLabel() {
            switch (this.$route.name) {
                case "live-showcase":
                    return "live diamond feed";
                case "stores-search-results-by-city":
                    return "jeweler city-stores";
                case "find-a-jeweler-by-city":
                    return "jeweler state-cities";
                case "find-a-jeweler-by-state":
                    return "jeweler store locator-state+city";
                case "engagement-rings-search":
                    return "main ring list";
                case "diamonds-page":
                    return "main diamond list";
                case "home-store":
                    return this.searchEngineType === "diamonds" ?
                        "jeweler diamond list" :
                        "jeweler ring list";
                default:
                    return "";
            }
        },
        // Dont send events greater than 200 elements because it lags the user's output too much!
        dl_ensureEventSending() {
            if (this.dl_click || this.dl_detailsObject) return true;
            return (
                this.dl_ecommerceType.objectsLst !== null &&
                this.dl_ecommerceType.objectsLst.length > 0
            );
        },
        dl_filteredCurrentStore() {
            let routesWithoutStoreInfo = ["engagement-rings-search", "diamonds-page"];
            return this.currentStore &&
                !routesWithoutStoreInfo.includes(this.$route.name) ?
                this.currentStore :
                null;
        },
        dl_getPosition() {
            let locateImpressions = {};
            locateImpressions =
                this.dl_currentObjectType === "rings" ?
                this.lastImpressions.find(
                    (i) => i.id === this.dl_clickedObject.internalID
                ) :
                this.lastImpressions.find(
                    (i) => i.id === this.dl_clickedObject.internal_lot
                );
            return locateImpressions && locateImpressions.position ?
                locateImpressions.position :
                null;
        },
    },
    methods: {
        ...mapActions("willyou", ["setLastImpressions"]),
        sendGaStupidObject(object) {
            window.dataLayer.push(object);
        },
        sendGADetails(detailsObject = {}) {
            this.dl_detailsObject = detailsObject;
            this.sendGA();
        },
        sendGAClick(clickedObject, currentRoute = null) {
            this.dl_currentRoute = currentRoute;
            this.dl_clickedObject = clickedObject;
            this.dl_click = true;
            this.sendGA();
        },
        sendGA(objectsArr = null) {
            if (this.dl_ensureEventSending) {
                let eventObj = {
                    event: this.dl_event,
                    ecommerceLabel: this.dl_ecommerceLabel,
                    ecommerce: {
                        currencyCode: "USD",
                    },
                };
                eventObj.ecommerce[
                    this.dl_ecommerceType.name
                ] = this.dl_ecommerceType.objectsLst;

                let impressionsArrayLength =
                    eventObj.ecommerce && eventObj.ecommerce.impressions ?
                    eventObj.ecommerce.impressions.length :
                    0;
                // Store mode page: if more than 200 impressions are loaded, split them to 200 chunks and send.
                if (impressionsArrayLength > 200) {
                    let impressions = chunk(eventObj.ecommerce.impressions, 200);
                    impressions.map((imp) => {
                        eventObj.ecommerce.impressions = imp;
                        window.dataLayer.push(eventObj);
                    });
                } else {
                    window.dataLayer.push(eventObj);
                }
            }
        },
        dl_getTypeObj(typeVariable) {
            this.dl_currentObjectType = typeVariable;
            switch (this.dl_event) {
                case "product click":
                    return this.dl_clickObject(typeVariable);
                case "product list":
                    return this.dl_impressions(typeVariable);
                case "product details":
                    return this.dl_details(typeVariable);
            }
        },
        dl_details(detailsObjectType) {
            let detailsObj = {};

            let ots = this.dl_detailsObject;
            switch (detailsObjectType) {
                case "rings":
                    detailsObj = {
                        actionField: { list: this.dl_ecommerceLabel },
                        products: [{
                            name: ots.name,
                            id: ots.internalID,
                            price: ots.TotalPrice,
                            brand: this.dl_filteredCurrentStore ?
                                this.dl_filteredCurrentStore.url :
                                "",
                            category: ots.ringShape,
                            variant: ots.ringColor,
                            list: this.dl_ecommerceLabel,
                        }, ],
                    };
                case "diamonds":
                    detailsObj = {
                        actionField: { list: this.dl_ecommerceLabel },
                        products: [{
                            name: ots.name,
                            id: ots.internal_lot,
                            price: ots.TotalPrice,
                            brand: this.dl_filteredCurrentStore ?
                                this.dl_filteredCurrentStore.url :
                                "",
                            category: ots.Color,
                            variant: ots.Shape,
                            list: this.dl_ecommerceLabel,
                        }, ],
                    };
            }
            return detailsObj;
        },
        dl_clickObject(clickObjectType = null) {
            let clickObject = {};
            switch (clickObjectType) {
                case "rings":
                    clickObject = {
                        actionField: { list: this.dl_ecommerceLabel },
                        products: [{
                            name: this.dl_clickedObject.name,
                            position: this.dl_getPosition,
                        }, ],
                    };
                    break;
                case "diamonds":
                    clickObject = {
                        actionField: { list: this.dl_ecommerceLabel },
                        products: [{
                            name: this.dl_clickedObject.name,
                            position: this.dl_getPosition,
                        }, ],
                    };
                    break;
            }
            return clickObject;
        },
        dl_impressions(impressionType = null) {
            let pos = 0;
            if (!this.objectsToShow && !this.storesAccurateToShow) return {};
            let impressions = [];
            switch (impressionType) {
                case "rings": // todo: ASK BENJI ABOUT DIAMOND SHAPE
                    impressions = this.objectsToShow.map((ots) => {
                        pos++;
                        return {
                            name: ots.name,
                            id: ots.internalID,
                            price: ots.TotalPrice,
                            brand: this.dl_filteredCurrentStore ?
                                this.dl_filteredCurrentStore.url :
                                "",
                            category: ots.ringShape,
                            variant: ots.ringColor,
                            list: this.dl_ecommerceLabel,
                            position: pos,
                        };
                    });
                    break;
                case "diamonds":
                    impressions = this.objectsToShow.map((ots) => {
                        pos++;
                        return {
                            name: ots.name,
                            id: ots.internal_lot,
                            price: ots.TotalPrice,
                            brand: this.dl_filteredCurrentStore ?
                                this.dl_filteredCurrentStore.url :
                                "",
                            category: ots.Color,
                            variant: ots.Shape,
                            list: this.dl_ecommerceLabel,
                            position: pos,
                        };
                    });
                    break;
                case "store-locator":
                    impressions = this.ga_impressions;
                    break;
                case "state-page":
                    impressions = this.currentState.cities.map((ots) => {
                        pos++;
                        return {
                            name: ots.name,
                            list: this.dl_ecommerceLabel,
                            position: pos,
                        };
                    });
                    break;
                case "jeweler-city":
                    impressions = this.storesAccurateToShow.map((ots) => {
                        pos++;
                        return {
                            name: ots.companyName,
                            list: this.dl_ecommerceLabel,
                            position: pos,
                        };
                    });
                    break;
            }
            this.setLastImpressions(impressions);
            return impressions;
        },
    },
};